// @flow
import * as React from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ai } from '../../utils/telemetryUtils';

// This component must be implemented as a class component to make it work with withAITracking HOC
class TelemetryProvider extends React.Component {
  constructor() {
    super();
    this.state = {
      initialized: false,
      initializedWithAuth: false,
    };
  }

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.configuration !== this.props.configuration ||
      prevProps.mobileNumber !== this.props.mobileNumber
    ) {
      this.initialize();
    }
  }

  initialize() {
    const { history, configuration, isConfigurationSet, mobileNumber } = this.props;
    const { initialized, initializedWithAuth } = this.state;

    if (!!history && isConfigurationSet) {
      if (!initializedWithAuth && mobileNumber) {
        ai.initialize(configuration.aiInstrumentationKey, history, (envelope) => {
          // eslint-disable-next-line no-param-reassign
          envelope.tags['ai.user.id'] = mobileNumber;
          // eslint-disable-next-line no-param-reassign
          envelope.tags['ai.user.authUserId'] = mobileNumber;
        });
        this.setState({ initialized: false, initializedWithAuth: true });
      } else if (!initialized && !mobileNumber) {
        ai.initialize(configuration.aiInstrumentationKey, history);
        this.setState({ initialized: true, initializedWithAuth: false });
      }
    }
  }

  render() {
    const { children } = this.props;
    return <React.Fragment>{children}</React.Fragment>;
  }
}

TelemetryProvider.propTypes = {
  children: PropTypes.object,
  history: PropTypes.any,
  isConfigurationSet: PropTypes.bool,
  configuration: PropTypes.object,
  mobileNumber: PropTypes.string,
};

TelemetryProvider.defaultProps = {
  children: {},
  history: {},
  isConfigurationSet: false,
  configuration: null,
  mobileNumber: null,
};

export default withRouter(withAITracking(ai.reactPlugin, TelemetryProvider));
